export default __webpack_public_path__ + "images/8e5fac326b0b96540bf754e9cdf680c3-renaissance.webp";